// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { getOrganizationAssetCurrencies } from '@/asset/api/get-organization-asset-currencies';
import { useQuery } from '@tanstack/react-query';

/**
 * Fetches the organization's distinct asset cost currencies for the report
 * currency picker. The list is org-wide, so it is shared across snapshot tabs.
 */
export function useOrganizationAssetCurrencies() {
  return useQuery({
    queryKey: ['organization-asset-currencies'],
    queryFn: getOrganizationAssetCurrencies,
  });
}
